(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector(".js-comment-news-swiper");
    if (!el || typeof Swiper === "undefined") return;

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 600,
      pagination: false,
      navigation: {
        nextEl: ".comment_news_next",
        prevEl: ".comment_news_prev",
      },
    });
  });
})();
